import type { CustomCellRendererProps } from "ag-grid-react";

import { FileIconComponent } from "@synthesis/shared-ui";

import { getFileExtension } from "./review-documents-tab.lib";
import type { TuPartRow, TuPartTableContext } from "./tu-parts.lib";

export const TuPartFileNameCell = ({ data, context }: CustomCellRendererProps<TuPartRow, unknown, TuPartTableContext>) => {
  if (!data) {
    return null;
  }

  if (!data.fileId || !data.fileName) {
    return <span className="paragraph-base text-type-light">Не загружен</span>;
  }

  return (
    <div className="flex min-w-0 items-center gap-2">
      <FileIconComponent className="size-6 shrink-0" ext={getFileExtension(data.fileName)} />
      <button
        type="button"
        className="paragraph-base text-system-info-50 min-w-0 truncate text-left hover:underline"
        onClick={() => context.onDownload(data)}
        title={data.fileName}
      >
        {data.fileName}
      </button>
    </div>
  );
};
